
export const SouscriptionSuiviActions = {
    SOUSCRIPTION_SUIVI_PAGE_LOADED_ACTION : { type : 'SouscriptionSuiviActions.SOUSCRIPTION_SUIVI_PAGE_LOADED_ACTION', build : (souscriptionId : string) => {return {type: SouscriptionSuiviActions.SOUSCRIPTION_SUIVI_PAGE_LOADED_ACTION.type, payload:{souscriptionId}}}},
};
